import { Base } from './base';
export class SecurityRequirement extends Base {
}
